import React, { memo, useState } from 'react';
import { TextInput } from 'components/atoms';

import { AdminFormLine } from 'theme/mixins';

import { SearchIcon } from './Search.styles';

interface Props {
  onSearch: (query: string) => void;
}

interface State {
  search: string;
}

const initialState: State = {
  search: ''
};

function Search(props: Props) {
  const { onSearch } = props;

  const [state, setState] = useState<State>(initialState);

  return (
    <AdminFormLine marginBottom>
      <TextInput
        placeholder="Search customers"
        innerInputStartAdornment={
          <SearchIcon />
        }
        value={state.search}
        onChange={(e) => {
          setState(prevState => ({
            ...prevState,
            search: e.target.value
          }));

          onSearch(e.target.value);
        }}
      />
    </AdminFormLine>
  );
};

export default memo(Search);

